<template>
  <div id="project-commissions">
    <SimplePageHeader title="Projects"></SimplePageHeader>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-layout column>
        <v-data-table
          class="mb-3"
          :headers="outerHeaders"
          :items="projectAssignmentGrossProfitItems"
          :items-per-page="-1"
          hide-default-footer
          show-expand
          item-key="projectId"
        >
          <template v-slot:item.individualGrossProfit="{ item }">
            {{ item.individualGrossProfit | currency }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-4">
              <v-data-table
                dense
                :headers="innerHeaders"
                :items="item.projectAssignments"
                :items-per-page="-1"
                item-key="assignmentId"
                hide-default-footer
              >
                <template v-slot:item.timeSheetHours="{ item }">
                  {{ item.timeSheetHours | formatDecimal }}
                </template>
                <template v-slot:item.employeeRole="{ item }">
                  {{ item.employeeRole | roleLabel }}
                </template>
                <template v-slot:item.monthlyTotalGrossProfit="{ item }">
                  {{ item.monthlyTotalGrossProfit | currency }}
                </template>
                <template v-slot:item.commissionPercent="{ item }">
                  {{ item.commissionPercent | percent }}
                </template>
                <template v-slot:item.monthlyIndividualGrossProfit="{ item }">
                  {{ item.monthlyIndividualGrossProfit | currency }}
                </template>
                <template v-slot:item.contractorCommissionGrossProfit="{ item }">
                  {{ item.contractorCommissionGrossProfit | currency }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    class="mx-1 my-1 hide-on-print"
                    color="primary"
                    outlined
                    @click.prevent="handleShowAssignmentDetails($event, item)"
                  >
                    <v-icon color="primary">badge</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { SimplePageHeader } from '@/components/pageComponents'
import { assignmentEditRoute } from '@/lib/constants/routes'
import { HOURLY as HOURLY_PAID } from '@/lib/constants/payRateTypes'
import { HOURLY as HOURLY_BILLED } from '@/lib/constants/billRateTypes'

export default {
  components: {
    SimplePageHeader
  },
  props: [
    'projectAssignmentGrossProfitItems'
  ],
  data () {
    return {
      HOURLY_PAID,
      HOURLY_BILLED,
      outerHeaders: [
        { text: 'Client', value: 'clientName', class: 'pl-4 pr-0', width: '40%' },
        { text: 'Project', value: 'projectName', class: 'pl-4 pr-0', width: '40%' },
        { text: 'Individual GP', value: 'individualGrossProfit', class: 'pl-2 pr-0', cellClass: 'pl-2', width: '20%' },
        { text: '', value: 'data-table-expand' }
      ],
      innerHeaders: [
        { text: 'Consultant', value: 'consultantName', class: 'pl-4 pr-0', width: '15%' },
        { text: 'Billable Hours', value: 'timeSheetHours', class: 'pl-4 pr-0', cellClass: 'pl-4', width: '10%' },
        { text: 'Contractor Commission GP', value: 'contractorCommissionGrossProfit', class: 'pl-2 pr-0', cellClass: 'pl-2', width: '15%' },
        { text: 'Role', value: 'employeeRole', class: 'pr-0', width: '10%' },
        { text: 'Total GP', value: 'monthlyTotalGrossProfit', class: 'hide-on-sm px-0', cellClass: 'hide-on-sm px-0', width: '10%' },
        { text: 'Commission %', value: 'commissionPercent', class: 'pl-2 pr-0', cellClass: 'pl-2', width: '10%' },
        { text: 'Individual GP', value: 'monthlyIndividualGrossProfit', class: 'pl-2 pr-0', cellClass: 'pl-2', width: '10%' },
        { text: 'Contract', value: 'actions', class: 'hide-on-print px-0', cellClass: 'hide-on-print', align: 'center', width: '5%', sortable: false }
      ]
    }
  },
  methods: {
    handleShowAssignmentDetails (event, item) {
      const routeData = this.$router.resolve({
        name: assignmentEditRoute.name,
        params: { id: item.assignmentId }
      })
      if (event.ctrlKey === true) {
        window.open(routeData.href, '_blank')
      } else {
        window.open(routeData.href, '_self')
      }
    }
  }
}
</script>
